import apiClient from './api';
import type { ShopCatalog, ShopCheckoutResponse } from '@/types/shop';

interface Envelope<T> {
  success: boolean;
  data: T;
}

export type ShopOrderState = 'pending' | 'activated' | 'completed_unlinked' | 'needs_review';

export const WC_SHOP_ORIGIN = (import.meta.env.VITE_WC_SHOP_ORIGIN || 'https://agile-assets.ai').replace(/\/$/, '');

export const shopApi = {
  async getCatalog(): Promise<ShopCatalog> {
    const response = await apiClient.get<Envelope<ShopCatalog>>('/api/shop/catalog');
    return response.data.data;
  },
  async createCheckout(items: Array<{ optionId: number; quantity: number }>): Promise<ShopCheckoutResponse> {
    const response = await apiClient.post<Envelope<ShopCheckoutResponse>>('/api/shop/checkout', { items }, { timeout: 45_000 });
    return response.data.data;
  },
  async getOrderStatus(orderId: number): Promise<{ state: ShopOrderState }> {
    const response = await apiClient.get<Envelope<{ state: ShopOrderState }>>(`/api/shop/orders/${orderId}/status`);
    return response.data.data;
  },
};

export const isSafeShopUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' && parsed.origin === WC_SHOP_ORIGIN;
  } catch {
    return false;
  }
};
